/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Video_CourseInputs */

const en_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Course`)
};

const es_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video curso`)
};

const fr_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours vidéo`)
};

const de_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videokurs`)
};

const ja_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオコース`)
};

const zh_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频课程`)
};

const ar_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دورة فيديو`)
};

const id_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursus Video`)
};

const it_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Corso`)
};

const ru_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеокурс`)
};

const pt_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curso em Vídeo`)
};

const ko_val_video_course = /** @type {(inputs: Val_Video_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비디오 코스`)
};

/**
* | output |
* | --- |
* | "Video Course" |
*
* @param {Val_Video_CourseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_video_course = /** @type {((inputs?: Val_Video_CourseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Video_CourseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_video_course(inputs)
	if (locale === "es") return es_val_video_course(inputs)
	if (locale === "fr") return fr_val_video_course(inputs)
	if (locale === "de") return de_val_video_course(inputs)
	if (locale === "ja") return ja_val_video_course(inputs)
	if (locale === "zh") return zh_val_video_course(inputs)
	if (locale === "ar") return ar_val_video_course(inputs)
	if (locale === "id") return id_val_video_course(inputs)
	if (locale === "it") return it_val_video_course(inputs)
	if (locale === "ru") return ru_val_video_course(inputs)
	if (locale === "pt") return pt_val_video_course(inputs)
	return ko_val_video_course(inputs)
});